import { ILangText } from "../ILangText";


const nav:{ [k:string]:ILangText }  = {};

const labels:{ [k:string]:ILangText }  = {};

const actions:{ [k:string]:ILangText }  = {
	"logOut":{
		en:"Log Out",
		is:"Skrá Út"
	},
	"openTutorial":{
		en:"Open Tutorial",
		is:"Opna leiðbeiningar"
	},
};

const messages:{ [k:string]:ILangText }  = {

};

Object.keys(labels).forEach(k => nav[`nav.label.${k}`] = labels[k]);
Object.keys(actions).forEach(k => nav[`nav.action.${k}`] = actions[k]);
Object.keys(messages).forEach(k => nav[`nav.message.${k}`] = messages[k]);

export { nav };